import { createContext, useContext, useEffect, useState } from 'react'
import portalApi from '../services/portalApi'

const PortalAuthContext = createContext(null)

export function PortalAuthProvider({ children }) {
  const [client, setClient] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = sessionStorage.getItem('lextrack_portal_token')
    if (!token) { setLoading(false); return }
    portalApi.get('/api/portal/me')
      .then(res => setClient(res.data))
      .catch(() => {
        sessionStorage.removeItem('lextrack_portal_token')
        setClient(null)
      })
      .finally(() => setLoading(false))
  }, [])

  const login = async (email, password) => {
    const res = await portalApi.post('/api/portal/login', { email, password })
    // If 2FA is enabled server-side, /login returns a challenge instead of
    // a token — hand it back to the caller so the login page can render
    // stage 2 (the TOTP code entry).
    if (res.data?.totp_required) return res.data
    sessionStorage.setItem('lextrack_portal_token', res.data.token)
    const me = await portalApi.get('/api/portal/me')
    setClient(me.data)
    return res.data
  }

  // Step 2 of a 2FA login — submit the TOTP (or backup) code + the challenge
  // token from step 1.  On success stores the real session token + hydrates
  // the client.
  const completeTotpLogin = async (challengeToken, code) => {
    const res = await portalApi.post('/api/portal/login/totp', {
      totp_challenge_token: challengeToken,
      code,
    })
    sessionStorage.setItem('lextrack_portal_token', res.data.token)
    const me = await portalApi.get('/api/portal/me')
    setClient(me.data)
    return res.data
  }

  const logout = () => {
    sessionStorage.removeItem('lextrack_portal_token')
    setClient(null)
    window.location.href = '/portal/login'
  }

  return (
    <PortalAuthContext.Provider value={{ client, loading, login, completeTotpLogin, logout }}>
      {children}
    </PortalAuthContext.Provider>
  )
}

export const usePortalAuth = () => useContext(PortalAuthContext)
